module.exports = __webpack_public_path__ + "static/media/toastmasters.31c27e21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/assets/toastmasters.jpg
// module id = 2452
// module chunks = 0